export const response = {
  startDate: "2025-11-24",
  endDate: "2025-11-29",
  threeMonthTrend: [
    {
      weekStart: "2025-08-25",
      count: 0,
    },
    {
      weekStart: "2025-09-01",
      count: 0,
    },
    {
      weekStart: "2025-09-08",
      count: 0,
    },
    {
      weekStart: "2025-09-15",
      count: 0,
    },
    {
      weekStart: "2025-09-22",
      count: 0,
    },
    {
      weekStart: "2025-09-29",
      count: 0,
    },
    {
      weekStart: "2025-10-06",
      count: 0,
    },
    {
      weekStart: "2025-10-13",
      count: 0,
    },
    {
      weekStart: "2025-10-20",
      count: 0,
    },
    {
      weekStart: "2025-10-27",
      count: 0,
    },
    {
      weekStart: "2025-11-03",
      count: 0,
    },
    {
      weekStart: "2025-11-10",
      count: 0,
    },
    {
      weekStart: "2025-11-17",
      count: 0,
    },
    {
      weekStart: "2025-11-24",
      count: 1,
    },
  ],
  dailyHeatmap: [
    {
      day: "Mon",
      date: "2025-11-24",
      hours: [
        {
          hour: "00:00",
          peakReservations: 0,
        },
        {
          hour: "01:00",
          peakReservations: 3,
        },
        {
          hour: "02:00",
          peakReservations: 0,
        },
        {
          hour: "03:00",
          peakReservations: 0,
        },
        {
          hour: "04:00",
          peakReservations: 0,
        },
        {
          hour: "05:00",
          peakReservations: 0,
        },
        {
          hour: "06:00",
          peakReservations: 0,
        },
        {
          hour: "07:00",
          peakReservations: 0,
        },
        {
          hour: "08:00",
          peakReservations: 0,
        },
        {
          hour: "09:00",
          peakReservations: 0,
        },
        {
          hour: "10:00",
          peakReservations: 5,
        },
        {
          hour: "11:00",
          peakReservations: 0,
        },
        {
          hour: "12:00",
          peakReservations: 4,
        },
        {
          hour: "13:00",
          peakReservations: 0,
        },
        {
          hour: "14:00",
          peakReservations: 0,
        },
        {
          hour: "15:00",
          peakReservations: 0,
        },
        {
          hour: "16:00",
          peakReservations: 0,
        },
        {
          hour: "17:00",
          peakReservations: 0,
        },
        {
          hour: "18:00",
          peakReservations: 0,
        },
        {
          hour: "19:00",
          peakReservations: 0,
        },
        {
          hour: "20:00",
          peakReservations: 0,
        },
        {
          hour: "21:00",
          peakReservations: 0,
        },
        {
          hour: "22:00",
          peakReservations: 0,
        },
        {
          hour: "23:00",
          peakReservations: 0,
        },
      ],
    },
    {
      day: "Tue",
      date: "2025-11-25",
      hours: [
        {
          hour: "00:00",
          peakReservations: 0,
        },
        {
          hour: "01:00",
          peakReservations: 0,
        },
        {
          hour: "02:00",
          peakReservations: 0,
        },
        {
          hour: "03:00",
          peakReservations: 0,
        },
        {
          hour: "04:00",
          peakReservations: 0,
        },
        {
          hour: "05:00",
          peakReservations: 0,
        },
        {
          hour: "06:00",
          peakReservations: 0,
        },
        {
          hour: "07:00",
          peakReservations: 0,
        },
        {
          hour: "08:00",
          peakReservations: 0,
        },
        {
          hour: "09:00",
          peakReservations: 0,
        },
        {
          hour: "10:00",
          peakReservations: 0,
        },
        {
          hour: "11:00",
          peakReservations: 0,
        },
        {
          hour: "12:00",
          peakReservations: 0,
        },
        {
          hour: "13:00",
          peakReservations: 0,
        },
        {
          hour: "14:00",
          peakReservations: 0,
        },
        {
          hour: "15:00",
          peakReservations: 0,
        },
        {
          hour: "16:00",
          peakReservations: 0,
        },
        {
          hour: "17:00",
          peakReservations: 0,
        },
        {
          hour: "18:00",
          peakReservations: 0,
        },
        {
          hour: "19:00",
          peakReservations: 0,
        },
        {
          hour: "20:00",
          peakReservations: 0,
        },
        {
          hour: "21:00",
          peakReservations: 0,
        },
        {
          hour: "22:00",
          peakReservations: 0,
        },
        {
          hour: "23:00",
          peakReservations: 0,
        },
      ],
    },
    {
      day: "Wed",
      date: "2025-11-26",
      hours: [
        {
          hour: "00:00",
          peakReservations: 0,
        },
        {
          hour: "01:00",
          peakReservations: 0,
        },
        {
          hour: "02:00",
          peakReservations: 0,
        },
        {
          hour: "03:00",
          peakReservations: 0,
        },
        {
          hour: "04:00",
          peakReservations: 0,
        },
        {
          hour: "05:00",
          peakReservations: 0,
        },
        {
          hour: "06:00",
          peakReservations: 0,
        },
        {
          hour: "07:00",
          peakReservations: 0,
        },
        {
          hour: "08:00",
          peakReservations: 0,
        },
        {
          hour: "09:00",
          peakReservations: 0,
        },
        {
          hour: "10:00",
          peakReservations: 0,
        },
        {
          hour: "11:00",
          peakReservations: 0,
        },
        {
          hour: "12:00",
          peakReservations: 0,
        },
        {
          hour: "13:00",
          peakReservations: 0,
        },
        {
          hour: "14:00",
          peakReservations: 0,
        },
        {
          hour: "15:00",
          peakReservations: 0,
        },
        {
          hour: "16:00",
          peakReservations: 0,
        },
        {
          hour: "17:00",
          peakReservations: 0,
        },
        {
          hour: "18:00",
          peakReservations: 0,
        },
        {
          hour: "19:00",
          peakReservations: 0,
        },
        {
          hour: "20:00",
          peakReservations: 0,
        },
        {
          hour: "21:00",
          peakReservations: 0,
        },
        {
          hour: "22:00",
          peakReservations: 0,
        },
        {
          hour: "23:00",
          peakReservations: 0,
        },
      ],
    },
    {
      day: "Thu",
      date: "2025-11-27",
      hours: [
        {
          hour: "00:00",
          peakReservations: 0,
        },
        {
          hour: "01:00",
          peakReservations: 0,
        },
        {
          hour: "02:00",
          peakReservations: 0,
        },
        {
          hour: "03:00",
          peakReservations: 0,
        },
        {
          hour: "04:00",
          peakReservations: 0,
        },
        {
          hour: "05:00",
          peakReservations: 0,
        },
        {
          hour: "06:00",
          peakReservations: 1,
        },
        {
          hour: "07:00",
          peakReservations: 1,
        },
        {
          hour: "08:00",
          peakReservations: 1,
        },
        {
          hour: "09:00",
          peakReservations: 1,
        },
        {
          hour: "10:00",
          peakReservations: 1,
        },
        {
          hour: "11:00",
          peakReservations: 1,
        },
        {
          hour: "12:00",
          peakReservations: 1,
        },
        {
          hour: "13:00",
          peakReservations: 1,
        },
        {
          hour: "14:00",
          peakReservations: 1,
        },
        {
          hour: "15:00",
          peakReservations: 1,
        },
        {
          hour: "16:00",
          peakReservations: 1,
        },
        {
          hour: "17:00",
          peakReservations: 1,
        },
        {
          hour: "18:00",
          peakReservations: 1,
        },
        {
          hour: "19:00",
          peakReservations: 1,
        },
        {
          hour: "20:00",
          peakReservations: 1,
        },
        {
          hour: "21:00",
          peakReservations: 1,
        },
        {
          hour: "22:00",
          peakReservations: 1,
        },
        {
          hour: "23:00",
          peakReservations: 1,
        },
      ],
    },
    {
      day: "Fri",
      date: "2025-11-28",
      hours: [
        {
          hour: "00:00",
          peakReservations: 1,
        },
        {
          hour: "01:00",
          peakReservations: 1,
        },
        {
          hour: "02:00",
          peakReservations: 1,
        },
        {
          hour: "03:00",
          peakReservations: 1,
        },
        {
          hour: "04:00",
          peakReservations: 1,
        },
        {
          hour: "05:00",
          peakReservations: 1,
        },
        {
          hour: "06:00",
          peakReservations: 1,
        },
        {
          hour: "07:00",
          peakReservations: 1,
        },
        {
          hour: "08:00",
          peakReservations: 1,
        },
        {
          hour: "09:00",
          peakReservations: 1,
        },
        {
          hour: "10:00",
          peakReservations: 1,
        },
        {
          hour: "11:00",
          peakReservations: 1,
        },
        {
          hour: "12:00",
          peakReservations: 1,
        },
        {
          hour: "13:00",
          peakReservations: 1,
        },
        {
          hour: "14:00",
          peakReservations: 1,
        },
        {
          hour: "15:00",
          peakReservations: 1,
        },
        {
          hour: "16:00",
          peakReservations: 1,
        },
        {
          hour: "17:00",
          peakReservations: 1,
        },
        {
          hour: "18:00",
          peakReservations: 0,
        },
        {
          hour: "19:00",
          peakReservations: 0,
        },
        {
          hour: "20:00",
          peakReservations: 0,
        },
        {
          hour: "21:00",
          peakReservations: 0,
        },
        {
          hour: "22:00",
          peakReservations: 0,
        },
        {
          hour: "23:00",
          peakReservations: 0,
        },
      ],
    },
    {
      day: "Sat",
      date: "2025-11-29",
      hours: [
        {
          hour: "00:00",
          peakReservations: 0,
        },
        {
          hour: "01:00",
          peakReservations: 0,
        },
        {
          hour: "02:00",
          peakReservations: 0,
        },
        {
          hour: "03:00",
          peakReservations: 0,
        },
        {
          hour: "04:00",
          peakReservations: 0,
        },
        {
          hour: "05:00",
          peakReservations: 0,
        },
        {
          hour: "06:00",
          peakReservations: 0,
        },
        {
          hour: "07:00",
          peakReservations: 0,
        },
        {
          hour: "08:00",
          peakReservations: 0,
        },
        {
          hour: "09:00",
          peakReservations: 0,
        },
        {
          hour: "10:00",
          peakReservations: 0,
        },
        {
          hour: "11:00",
          peakReservations: 0,
        },
        {
          hour: "12:00",
          peakReservations: 0,
        },
        {
          hour: "13:00",
          peakReservations: 0,
        },
        {
          hour: "14:00",
          peakReservations: 0,
        },
        {
          hour: "15:00",
          peakReservations: 0,
        },
        {
          hour: "16:00",
          peakReservations: 0,
        },
        {
          hour: "17:00",
          peakReservations: 0,
        },
        {
          hour: "18:00",
          peakReservations: 0,
        },
        {
          hour: "19:00",
          peakReservations: 0,
        },
        {
          hour: "20:00",
          peakReservations: 0,
        },
        {
          hour: "21:00",
          peakReservations: 0,
        },
        {
          hour: "22:00",
          peakReservations: 0,
        },
        {
          hour: "23:00",
          peakReservations: 0,
        },
      ],
    },
    {
      day: "Sun",
      date: "2025-11-30",
      hours: [
        {
          hour: "00:00",
          peakReservations: 0,
        },
        {
          hour: "01:00",
          peakReservations: 3,
        },
        {
          hour: "02:00",
          peakReservations: 0,
        },
        {
          hour: "03:00",
          peakReservations: 0,
        },
        {
          hour: "04:00",
          peakReservations: 0,
        },
        {
          hour: "05:00",
          peakReservations: 0,
        },
        {
          hour: "06:00",
          peakReservations: 0,
        },
        {
          hour: "07:00",
          peakReservations: 7,
        },
        {
          hour: "08:00",
          peakReservations: 0,
        },
        {
          hour: "09:00",
          peakReservations: 0,
        },
        {
          hour: "10:00",
          peakReservations: 5,
        },
        {
          hour: "11:00",
          peakReservations: 0,
        },
        {
          hour: "12:00",
          peakReservations: 4,
        },
        {
          hour: "13:00",
          peakReservations: 0,
        },
        {
          hour: "14:00",
          peakReservations: 0,
        },
        {
          hour: "15:00",
          peakReservations: 0,
        },
        {
          hour: "16:00",
          peakReservations: 10,
        },
        {
          hour: "17:00",
          peakReservations: 0,
        },
        {
          hour: "18:00",
          peakReservations: 0,
        },
        {
          hour: "19:00",
          peakReservations: 0,
        },
        {
          hour: "20:00",
          peakReservations: 0,
        },
        {
          hour: "21:00",
          peakReservations: 0,
        },
        {
          hour: "22:00",
          peakReservations: 0,
        },
        {
          hour: "23:00",
          peakReservations: 0,
        },
      ],
    },
  ],
};

const sampleData = [
    {
      day: "Mon",
      date: "2025-11-24",
      hours: Array.from({ length: 24 }, (_, i) => ({
        hour: `${String(i).padStart(2, '0')}:00`,
        peakReservations: i >= 7 && i <= 10 ? 85 : i >= 11 && i <= 15 ? 65 : i === 10 ? 55 : 0
      }))
    },
    {
      day: "Tue",
      date: "2025-11-25",
      hours: Array.from({ length: 24 }, (_, i) => ({
        hour: `${String(i).padStart(2, '0')}:00`,
        peakReservations: i >= 7 && i <= 10 ? 90 : i >= 11 && i <= 14 ? 70 : i === 11 ? 30 : i === 15 ? 45 : 0
      }))
    },
    {
      day: "Wed",
      date: "2025-11-26",
      hours: Array.from({ length: 24 }, (_, i) => ({
        hour: `${String(i).padStart(2, '0')}:00`,
        peakReservations: i >= 7 && i <= 10 ? 85 : i >= 11 && i <= 15 ? 65 : i === 10 ? 55 : 0
      }))
    },
    {
      day: "Thu",
      date: "2025-11-27",
      hours: Array.from({ length: 24 }, (_, i) => ({
        hour: `${String(i).padStart(2, '0')}:00`,
        peakReservations: i >= 7 && i <= 10 ? 88 : i >= 11 && i <= 14 ? 60 : i === 12 ? 50 : i === 14 ? 45 : 0
      }))
    },
    {
      day: "Fri",
      date: "2025-11-28",
      hours: Array.from({ length: 24 }, (_, i) => ({
        hour: `${String(i).padStart(2, '0')}:00`,
        peakReservations: i >= 7 && i <= 10 ? 92 : i >= 12 && i <= 15 ? 72 : i === 6 ? 45 : i === 11 ? 50 : 0
      }))
    },
    {
      day: "Sat",
      date: "2025-11-29",
      hours: Array.from({ length: 24 }, (_, i) => ({
        hour: `${String(i).padStart(2, '0')}:00`,
        peakReservations: i >= 9 && i <= 15 ? 80 : i === 9 ? 55 : 0
      }))
    },
    {
      day: "Sun",
      date: "2025-11-30",
      hours: Array.from({ length: 24 }, (_, i) => ({
        hour: `${String(i).padStart(2, '0')}:00`,
        peakReservations: i >= 9 && i <= 15 ? 82 : i === 9 ? 55 : 0
      }))
    }
  ];
